/** A referential catalogue: no tenant, no parameter. */
class FetchAiProviderKinds {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAiProviderKinds;
